require("!!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\raw-loader\\index.js!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\node_modules\\source-map-loader\\index.js!C:\\Users\\TEJADA\\Desktop\\PROYECTOS MGS\\imm\\V3\\front\\src\\modernizr.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./src/modernizr.js
// module id = 807
// module chunks = 5